import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Home, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { setActiveCompany } from "@/lib/activeCompany";
import { TOUR_KEY } from "@/components/common/DemoTour";
import { cn } from "@/lib/utils";

const OPTIONS = [["personal", "Démo Particulier", Home, "/"], ["business", "Démo Entreprise", Building2, "/entreprise"]];

export const DemoButtons = ({ dark = false, className }) => {
  const { startDemo } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(null);
  const go = async (space, to) => {
    setBusy(space);
    try {
      sessionStorage.setItem(TOUR_KEY, space);
      const me = await startDemo(space);
      const main = (me.companies || []).find((c) => !/Studio/.test(c.name)) || me.companies?.[0];
      if (main) setActiveCompany(main.id);
      navigate(to);
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(null); }
  };
  return (
    <div className={cn("space-y-2", className)} data-testid="demo-buttons">
      <p className={cn("text-xs font-semibold", dark ? "text-white/70" : "text-muted-foreground")}>Découvrir sans créer de compte, avec une démo privée et déjà remplie :</p>
      <div className="flex flex-wrap gap-2">{OPTIONS.map(([space, label, Icon, to]) => (
        <button key={space} type="button" disabled={!!busy} onClick={() => go(space, to)} data-testid={`demo-start-${space}`}
          className={cn("inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-bold transition-colors disabled:opacity-60",
            dark ? "border-white/25 bg-white/10 text-white hover:bg-white/20" : "border-border bg-card hover:bg-secondary")}>
          {busy === space ? <Loader2 className="h-4 w-4 animate-spin" /> : <Icon className="h-4 w-4" />}{label}</button>))}</div>
    </div>
  );
};
